module.exports = __webpack_public_path__ + "img/PG5-1-498x299.498e5484.png";